import { createSelector } from 'reselect';

export const productProductsSelector = (state) => state.pages.products;

export const productCurrentProductIdSelector = (state) => state.pages.productId;

export const productsProductsListSelector = createSelector([productProductsSelector], (products) =>
    Object.values(products)
);

export const productsMainProductsSelector = createSelector(
    [productsProductsListSelector, productCurrentProductIdSelector],
    (products, currentProductId) => {
        const mainProduct = products?.filter(
            (product) => +product.product_id === +currentProductId
        );
        return mainProduct.length > 0 ? mainProduct[0] : {};
    }
);

/**
 * Resolves the listing of domains for corresponded product selector.
 * Currently, it's applicable only for SSL (product_id = 5).
 */
export const productCurrentDomainsSelector = createSelector(
    [productsMainProductsSelector],
    (product) => {
        // Product ID is hard-coded across the code.
        // Potentially that could be refactored to use mapping between product_id and actual product name.
        // Otherwise, currently is used the same approach of product_id mapping.
        // 5 stands to "SSL Certificate".
        if (product?.product_id === 5) {
            // "ssl_certs" : [
            //  0: {
            //      "cert_id": 5671,
            //      "domain: "test-b.com"
            // ]
            return Array.isArray(product?.ssl_certs) ? product.ssl_certs : [];
        }
        return [];
    }
);

export const productAvailableAccountsSelector = createSelector(
    [productsMainProductsSelector],
    (product) => {
        // Currently only doBoard product supports accounts.
        if (product?.product_id === 7) {
            return Array.isArray(product?.accounts) ? product.accounts : [];
        }
        return [];
    }
);
